import { z } from "zod/v4";

export const StripeApiMeterDtoSchema = z.object({
  id: z.string(),
  customerId: z.string(),
  name: z.string(),
  value: z.number(),
  startTime: z.number(),
  endTime: z.number(),
});

export type StripeApiMeterDto = z.infer<typeof StripeApiMeterDtoSchema>;
